import type { Familia } from './salesData'

interface FamiliaStyle {
  /** Hex del color de la familia (para sombras, luces y bordes inline). */
  hex: string
  /** Texto del color de la familia. */
  text: string
  /** Borde del color de la familia. */
  border: string
  /** Relleno tenue del color de la familia. */
  tint: string
}

/**
 * Un color por familia de recetas, igual que en las portadas del mockup:
 * verde para PANES, rojo para PIZZAS, dorado para PASTAS, violeta para POSTRES.
 */
export const FAMILIA_STYLES: Record<Familia, FamiliaStyle> = {
  panes: {
    hex: '#8CC63F',
    text: 'text-keto-pan',
    border: 'border-keto-pan/45',
    tint: 'bg-keto-pan/10',
  },
  pizzas: {
    hex: '#E33B2E',
    text: 'text-keto-pizza',
    border: 'border-keto-pizza/45',
    tint: 'bg-keto-pizza/10',
  },
  pastas: {
    hex: '#FFC400',
    text: 'text-keto-pasta',
    border: 'border-keto-pasta/45',
    tint: 'bg-keto-pasta/10',
  },
  postres: {
    hex: '#A768F0',
    text: 'text-keto-postre',
    border: 'border-keto-postre/45',
    tint: 'bg-keto-postre/10',
  },
}
